<template>
    <div  style="margin-bottom:51px !important;
        margin-top: -11px;">
    <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show" :timeout="1000" top>
        {{ snackbar.message }}
    </v-snackbar>
        <loading :active.sync="isLoading" 
        
        :is-full-page="fullPage">
          </loading>
          
               
        <v-container style="margin-top: -11px;height: 100vh;" v-show="visibleshow" >
          
         
          
     <!-- /////////////////////////////////////////getfullitemdata -->
     <v-row dense  >
         <v-col
    
          cols="12" 
         
         
        >
       
     <v-card  light style="color:grey"  >
      
       <div @click="openitem(getfullitemdata.Barcode,item,position)">
            <v-avatar
                class="ma-3"
                style="width:100%; height:200px;"
                tile
              >
                <v-img :src="imgURL+getfullitemdata.ItemCode+'.jpg'" :id="getfullitemdata.Barcode"  @error="setAltImg(getfullitemdata.Barcode)" :alt="getfullitemdata.ItemCode+'.jpg'" ></v-img>
               
              </v-avatar>

               
       </div>
       <div class="mx-auto text-center">
          <v-row >
             <v-col cols="12" style=" color: #030303;border-bottom: 1px solid #ff2f006e;">
                <b style="font-size: 14px;"
                  class="headline cs"
                > {{getfullitemdata.ItemName}}</b><br>
                <b style="font-size: 10px;"
                  class="headline cs"
               > {{getfullitemdata.ArabicName}}</b>
             </v-col>
            <v-col cols="12">
             <span style="color:#000;font-size:15px;"><b style="color:#000;font-size:10px;">{{currency}}</b>&nbsp;</span><b style="color:#009900;font-size:2em;">{{ formatPrice(getfullitemdata.SellingRate) }}</b> <s v-if="getfullitemdata.SellingRate != getfullitemdata.PrevSellRate" style="color:red;padding-left:10px;">{{ formatPrice(getfullitemdata.PrevSellRate) }}</s>
           </v-col>
          </v-row>
         <v-row>
             <v-col cols="2">
             </v-col>
           <v-col cols="8">
              <v-img :src="barimg" style="height:80px;width:100%" />
              <b>{{getfullitemdata.Barcode}}</b>
           </v-col>
            <v-col cols="2">
             </v-col>
          
         </v-row>
        
       </div>
    <v-row no-gutters>
      <v-col cols="4" :id="getfullitemdata.SellingRate"  @click="addwishlist(getfullitemdata.ItemName,position,getfullitemdata.Barcode)" >
        <v-btn icon >
          <v-icon :id="getfullitemdata.Barcode+getfullitemdata.ItemName">mdi-heart</v-icon>
        </v-btn>
      </v-col>
      <v-col class="4" :id="getfullitemdata.SellingRate"  @click="adcart(getfullitemdata.ItemName,position,getfullitemdata.Barcode,getfullitemdata.ArabicName)">
              <v-btn icon  >
                <v-icon :id="getfullitemdata.Barcode+getfullitemdata.ArabicName">mdi-cart</v-icon>
                
              </v-btn>
      </v-col>
    
      <v-col class="4">
              <v-btn icon >
                <a :href="link"
            target="_blank"> 
          
        <v-icon>mdi-share-variant</v-icon> </a>
              </v-btn>
     </v-col>
    </v-row>
     </v-card>
    </v-col>
       
    </v-row>
        
        </v-container>
    </div>
</template>
<script>
import Vue from 'vue'
 import axios from 'axios';
 import Loading from 'vue-loading-overlay';
 import Router from '../router';
 import 'vue-loading-overlay/dist/vue-loading.css';


export default {
     components: {
            Loading
        },
    data: () => ({
         name: 'Item Details',
 imgURL:'',
 barimg:'https://p.kindpng.com/picc/s/77-771409_barcode-png-images-transparent-background-barcode-png-png.png',
         barcode:'',
         link:'',
         isLoading: false,
         fullPage: true,
         visibleshow:false,
         scrcount : 1,
          cartlist:[],
          cartitem:[],
          wishlist:[],
           clicked: [],
           timeout: 1500,
           wishclicked: [],
           carclicked:[],
           scrollproducts : [],
           cartcolorbar:[],
           currency:'',
           type:'',
           snackbar: {
                show: false,
                message: null,
                color: null
            },
           items:[],
           prodyc:[],
           position:'',
           getfullitemdata:[],
         item:
         {
            barcode:'',
             img:'',
             itemname:'',
             arabicname:'',
             sellrate:'',
             Description:'',
         }
         

    }),
    watch: {
    scrcount: function(newValue, oldValue) {
     console.log(newValue+" "+oldValue)
   
    }
    },
    mounted() {
      this.barcode = localStorage.getItem("barcode");
      this.link = "https://api.whatsapp.com/send?text=https://sitenewn.firebaseapp.com/?Barcode="+this.barcode
      this.getfullitemdata = JSON.parse(localStorage.getItem("singleviewfullitem"))
      this.position = localStorage.getItem("pos");
      this.type = localStorage.getItem("type");
      this.imgURL = localStorage.getItem("imgUrl");
    this.currency = localStorage.getItem("currency");
    this.decimalPlaces=localStorage.getItem("decimalPlaces");
    this.$parent.$children[0].$parent.ttlval = this.name
     
     this.getscrollItems();
     this.getitembyPos();
     this.$parent.$children[0].$parent.$parent.itemcountnumber = localStorage.getItem('countitemno');
     setTimeout(this.setcartcolor, 1000)
    
    },
    methods: {
      getitembyPos(){
         console.log("Position"+this.position)
         for(this.i=0;this.i<this.getfullitemdata.length;this.i++)
           {
             if(this.i == this.position){
              //  this.getfullitemdata.pos=this.i
              //  this.prodyc.index =  this.i
               this.items = this.getfullitemdata[this.i]
               console.log("items" + this.items)
              
             }
           }
      },
      setAltImg(bar) { 
        this.imgURL = localStorage.getItem("imgUrl");
          this.urlimg = "url("+this.imgURL+"ItemImage.jpg)";
       console.log("aa "+this.urlimg)
         document.getElementById(bar).style.backgroundImage = this.urlimg
         document.getElementById(bar).style.backgroundPosition = "center center";
          document.getElementById(bar).style.backgroundSize = "cover"
       
     }, 
    //-------------------------------------

       formatPrice(value) {
        const val = (value/1).toFixed(  this.decimalPlaces);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
        getscrollItems: function () {
            
       this.isLoading = true;
    //   this.loading = true;
      axios.get(this.$bURL+"Item/GetItemByBarcode?Barcode="+this.barcode)
      .then((response)  =>  {
        // this.loading = false;
         
       
        this.visibleshow = true
        console.log(response.data[0])
        //  this.items = response.data[0];
        setTimeout(() => {
                  this.isLoading = false
         },1000)
      }, (error)  =>  {
          console.log(error)
      })
    },
      //cart Adding Function
 

    adcart: function (name,pos,bar,arb) {

     if (localStorage.getItem("carclicked") === null) {
  
      this.clicked.push(bar+arb)
     localStorage.setItem("carclicked",JSON.stringify(this.clicked))
       }else{
            this.clicked = JSON.parse(localStorage.getItem("carclicked"))
         this.clicked.push(bar+arb)
          localStorage.setItem("carclicked",JSON.stringify(this.clicked))
       
       }


     
     console.log("id "+ name+" pos "+pos)
      document.getElementById(bar+arb).style.color = '#009900';
    // if(this.cartlist.includes(this.scrollproducts[pos])) {
          //  document.getElementById("6950086683397").style.color = '#009900';
    //       alert("already there");
          
    //     }else{
      this.cart =JSON.parse(localStorage.getItem("cartlist"))
      if(this.cart!=null || this.cart!=undefined)
      {
            this.cartlist = this.cart;
      }
            
         this.flag=false; 
          this.flagid='';
       if(this.cartlist!=null || this.cartlist!=undefined)
       {
          for(this.i=0;this.i<this.cartlist.length;this.i++)
           {
             if( this.cartlist[this.i].Barcode===this.getfullitemdata[pos].Barcode)
             {
               this.flag=true; 
               this.flagid=this.i; 
               break;
             }
           }
           if(this.flag===true)
           {
             console.log(this.cartlist[this.flagid].count);
             this.cartlist[this.flagid].count+=1
           }
           else{
             this.getfullitemdata[pos].count=1;
             this.cartlist.push(this.getfullitemdata[pos]);
           }
       }
      else {
          this.cartlist.push(this.getfullitemdata[pos]);
       }
    
      // this.cartlist.push(this.scrollproducts[pos]);
          this.cartitem = this.cartlist;
           this.$parent.$children[0].$parent.$parent.addedcartitem = this.cartlist;
        localStorage.setItem("cartlistarray",JSON.stringify(this.cartlist))
        localStorage.setItem("cartcount",this.cartlist.length)
         this.$parent.$children[0].$parent.$parent.itemcountnumber = this.cartlist.length;
        localStorage.setItem("cartlist", JSON.stringify(this.cartlist));

        this.snackbar = {
                        message: 'Item Added Successfully',
                        color: 'success',
                        show: true
                    }
        // }
      

     
   
    },
       addwishlist: function (name,pos,bar) {
          console.log("id "+ name+" pos "+pos+" bar "+bar)



      this.wish =JSON.parse(localStorage.getItem("wishlist"))
      if(this.wish!=null || this.wish!=undefined)
      {
            this.wishlist = this.wish;
      }
            
         this.flag=false; 
          this.flagid='';
       if(this.wishlist!=null || this.wishlist!=undefined)
       {
          for(this.i=0;this.i<this.wishlist.length;this.i++)
           {
             if( this.wishlist[this.i].Barcode===this.getfullitemdata[pos].Barcode)
             {
               this.flag=true; 
               this.flagid=this.i; 
               break;
             }
           }
           if(this.flag===true)
           {
             console.log(this.wishlist[this.flagid].count);
             this.wishlist[this.flagid].count+=1
           }
           else{
             this.getfullitemdata[pos].count=1;
             this.wishlist.push(this.getfullitemdata[pos]);
           }
       }
      else {
          this.wishlist.push(this.scrollproducts[pos]);
       }
    
      // this.cartlist.push(this.scrollproducts[pos]);
          this.wishitem = this.wishlist;
if (localStorage.getItem("wishclicked") !== null) {
          this.wishdata = localStorage.getItem("wishclicked");
          this.n =  this.wishdata.includes(bar+name);
          this.myArray = JSON.parse(localStorage.getItem("wishlist"));
}else
{
  this.n = false
}
// console.log(this.n)

          if(this.n){
             this.wishdata = JSON.parse(localStorage.getItem("wishclicked"));
              document.getElementById(bar+name).style.color = 'grey';
               this.index = this.wishdata.indexOf(bar+name);
               console.log(this.index)

               this.wishdata.splice(this.index,1); 
              console.log(JSON.stringify(this.wishdata));
              // this.arr = this.wishdata.filter(e => e !== bar+name); // will return ['A', 'C']
               localStorage.setItem("wishclicked",JSON.stringify(this.wishdata))
                this.myArray.splice(this.index,1);
               localStorage.setItem("wishlist", JSON.stringify(this.myArray));
  
          }else{
             document.getElementById(bar+name).style.color = 'red';
            if (localStorage.getItem("wishclicked") === null) {
  
        this.wishclicked.push(bar+name)
       localStorage.setItem("wishclicked",JSON.stringify(this.wishclicked))
    
       }else{
            this.wishclicked = JSON.parse(localStorage.getItem("wishclicked"))
          this.wishclicked.push(bar+name)
       localStorage.setItem("wishclicked",JSON.stringify(this.wishclicked))
       
       }
        
        localStorage.setItem("wishlist", JSON.stringify(this.wishlist));

          }

       

       
      

     
   
    },
     setcartcolor: function(){
           if(localStorage.getItem("carclicked")!== null)
    {
      
      this.loopcart = JSON.parse(localStorage.getItem("carclicked"));
      

      for(this.i=0;this.i<this.loopcart.length; this.i++)
        {

          
          
          this.var = this.loopcart[this.i]

          document.getElementById(this.loopcart[this.i]).style.color = '#009900';
            
           if(localStorage.getItem("wishclicked")!== null)
     {
         this.loopwish = JSON.parse(localStorage.getItem("wishclicked"));
      

        for(this.i=0;this.i<this.loopwish.length; this.i++)
        {
          console.log("ya"+this.loopwish[this.i])
          this.var = this.loopwish[this.i]
          document.getElementById(this.loopwish[this.i]).style.color = 'red';
           
        }
     
    }
        
        }
    }
     if(localStorage.getItem("wishclicked")!== null)
     {
         this.loopwish = JSON.parse(localStorage.getItem("wishclicked"));
      

        for(this.i=0;this.i<this.loopwish.length; this.i++)
        {
          console.log("ya"+this.loopwish[this.i])
          this.var = this.loopwish[this.i]
          document.getElementById(this.loopwish[this.i]).style.color = 'red';
           
        }
     
    }
      },
    
    }
}

</script>
<style>
.snackbar{
  background-color:black;
}
.v-snack__wrapper {
    align-items: center;
    background-color: #28a745 !important;
    border-radius: 25px;
}
.v-snack .v-snack--active{
 background-color: #28a745 !important;
}

</style>